import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { cn } from '../../lib/utils';

// DVS monogram + wordmark. The monogram is the brand artwork; the wordmark is set in type.
// `onInk` picks the light-on-dark artwork when the logo sits over an ink section.
const Logo = ({ className, onClick, onInk = false }) => {
  const { theme } = useTheme();
  const dark = onInk || theme === 'dark';
  return (
    <Link to="/" onClick={onClick} className={cn('group inline-flex items-center gap-3', className)} aria-label="Dreamvision Solutions home">
      <img
        src={dark ? '/brand/mark-dark.png' : '/brand/mark-light.png'}
        alt=""
        width="44"
        height="21"
        className="h-[21px] w-auto transition-transform duration-500 ease-out-expo group-hover:scale-105"
      />
      <span className="hidden text-[0.9375rem] font-semibold leading-none tracking-[-0.02em] [font-stretch:110%] sm:inline">
        Dreamvision <span className="font-normal text-muted-foreground">Solutions</span>
      </span>
    </Link>
  );
};

export default Logo;
